$(function(){
	$select_option = $(".box_select_option select");
	$select_option_series = $("select[name='select_option_series']");
	$select_option_site = $("select[name='select_option_site']");
	$select_option_worries = $("select[name='select_option_worries']");
	$select_option.change(function(){
		$select_option_series2 = $select_option_series.val();
		$select_option_site2 = $select_option_site.val();
		$select_option_worries2 = $select_option_worries.val();
		if($select_option_series2 =="" && $select_option_site2=="" && $select_option_worries2==""){
			$('ul.list_howto li').addClass('active_list');
		}
		else if($select_option_series2 != "" && $select_option_site2 == "" && $select_option_worries2 == ""){
			$('ul.list_howto li').each(function (){
				$(this).removeClass('active_list');
					if($(this).hasClass($select_option_series2) ){
						$(this).addClass('active_list');
					}else{
						$(this).removeClass('active_list');
					}
			});
		}
		else if($select_option_series2 == "" && $select_option_site2 != "" && $select_option_worries2 == ""){
			$('ul.list_howto li').each(function (){
				$(this).removeClass('active_list');
					if($(this).hasClass($select_option_site2) ){
						$(this).addClass('active_list');
					}else{
						$(this).removeClass('active_list');
					}
			});
		}
		else if($select_option_series2 == "" && $select_option_site2 == "" && $select_option_worries2 != ""){
			$('ul.list_howto li').each(function (){
				$(this).removeClass('active_list');
					if($(this).hasClass($select_option_worries2) ){
						$(this).addClass('active_list');
					}else{
						$(this).removeClass('active_list');
					}
			});
		}
		else if($select_option_series2 != "" && $select_option_site2 != "" && $select_option_worries2 == ""){
			$('ul.list_howto li').each(function (){
				$(this).removeClass('active_list');
					if($(this).hasClass($select_option_series2) && $(this).hasClass($select_option_site2) ){
						$(this).addClass('active_list');
					}else{
						$(this).removeClass('active_list');
					}
			});
		}
		else if($select_option_series2 != "" && $select_option_site2 == "" && $select_option_worries2 != ""){
			$('ul.list_howto li').each(function (){
				$(this).removeClass('active_list');
					if($(this).hasClass($select_option_series2) && $(this).hasClass($select_option_worries2) ){
						$(this).addClass('active_list');
					}else{
						$(this).removeClass('active_list');
					}
			});
		}
		else if($select_option_series2 == "" && $select_option_site2 != "" && $select_option_worries2 != ""){
			$('ul.list_howto li').each(function (){
				$(this).removeClass('active_list');
					if($(this).hasClass($select_option_site2) && $(this).hasClass($select_option_worries2) ){
						$(this).addClass('active_list');
					}else{
						$(this).removeClass('active_list');
					}
			});
		}
		else if($select_option_series2 != "" && $select_option_site2 != "" && $select_option_worries2 != ""){
			$('ul.list_howto li').each(function (){
				$(this).removeClass('active_list');
					if($(this).hasClass($select_option_series2) && $(this).hasClass($select_option_site2) && $(this).hasClass($select_option_worries2) ){
						$(this).addClass('active_list');
					}else{
						$(this).removeClass('active_list');
					}
			});
		}
		
		else{
			return false;
		}
		
		if($('ul.list_howto li').hasClass('active_list')){
			$("ul.list_howto li.list_howto_none").removeClass('active_list2');
		}else{
			$("ul.list_howto li.list_howto_none").addClass('active_list2');
		}
	});
	
	$('.btn_reset span').click(function() {
		$select_option_series.val("");
		$select_option_site.val("");
		$select_option_worries.val("");
		$('ul.list_howto li').addClass('active_list');
	});

	// youtube thumbnail
	if($(".js-youtubeThumb")[0]){
		$(".js-youtubeThumb").each(function(){
			var ytID = $(this).data('ytid');
			$(this).css({'background-image':'url(https://img.youtube.com/vi/'+ytID+'/hqdefault.jpg)'})
		});
	}
    /**
     * Modal open
     */
    // Common
    $('.js-modalOpen').on('click', function(){
        var modalID = $(this).data('modal');
        $('#' + modalID).fadeIn(500);
        $('.modalBox').fadeIn(500);
        $('body').css({'overflow':'hidden'});
    });
    // Youtube
    $('.js-youtubePlay').on('click', function(){
        var ytID = $(this).data('ytid');
        var ytURL = 'https://www.youtube.com/embed/'+ytID+'?autoplay=1&rel=0';
        setTimeout(function(){
            $('.js-youtubeIframe').attr('src',ytURL);
        },100);
    });
    /**
     * Modal close
     */
    var $modalIF = $('.js-youtubeIframe');
    // Close
    function modalClose() {
        $('.modalBox, .oneModal').fadeOut(500);
        setTimeout(function(){
            $modalIF.attr('src','');
        },500);
        $('body').css({'overflow':''});
    }
    // Close
    $('.js-modalClose').on('click', function(){
        modalClose();
    });
    // Close
    $('.js-oneModalIn').on('click touchend', function(e) {
        if (!$(e.target).closest('.js-oneModalIn__cont').length) {
            modalClose();
        }
    });

});
$(function(){
$('ul.list_howto li').matchHeight();
$('.title_list_howto').matchHeight();
$('.box_list_howto').matchHeight();
});
